export const PATH_LOGIN = "/login";
export const PATH_CHOOSE_ORGANISATION = "/choose-organisation";
export const PATH_RESET_PASSWORD = "/reset-password";
export const PATH_RESET_PASSWORD_CONFIRMED = PATH_RESET_PASSWORD + "/confirmed";
export const PATH_NEW_PASSWORD = "/new-password/:token";
export const PATH_NEW_PASSWORD_CONFIRMED = PATH_NEW_PASSWORD + "/confirmed";

export const PATH_REGISTER = "/register";
export const PATH_REGISTER_COMPANY = "/register-subscription";
export const PATH_REGISTER_COMPANY_STEP = "/register-subscription/:accountType/:step";

export const PATH_REGISTER_CONFIRMED = PATH_REGISTER + "/confirmed";
export const PATH_REGISTER_VERIFIED = PATH_REGISTER + "/verify/:token";
export const PATH_REGISTER_INVITE = PATH_REGISTER + "/invite/:token";

export const PATH_CHANGE_ORGANISATION = "/company/:id/change";
export const PATH_LOGOUT = "/logout";

export const PATH_DASHBOARD = "/dashboard";
export const PATH_MY_ACCOUNT = "/my-account";

export const PATH_SALES_SESSIONS = "/sessions";

export const PATH_SALES_PAYOFF = "/payoffs";

export const PATH_SYSTEM_LOGS = "/system-logs";
export const PATH_ACCOUNT_BILLING = "/account-billing";
export const PATH_USERS = "/users";
export const PATH_USERS_ADD = "/users/add";
export const PATH_USERS_EDIT = "/users/:id/edit";
export const PATH_CUSTOMER_AKA_USER_ADD = "/users/home/add";
export const PATH_CUSTOMER_AKA_USER_EDIT = "/users/home/:id/edit";

export const PATH_CUSTOMERS = "/customers";
export const PATH_CUSTOMERS_ADD = "/customers/add";
export const PATH_CUSTOMERS_EDIT = "/customers/:id/edit";

export const PATH_EMPLOYEE = "/employees";
export const PATH_EMPLOYEE_ADD = "/employees/add";
export const PATH_EMPLOYEE_EDIT = "/employees/:id/edit";

export const PATH_TARIFFS = "/tariffs";
export const PATH_TARIFFS_ADD = "/tariffs/add";
export const PATH_TARIFFS_COPY = "/tariffs/:id/copy";
export const PATH_TARIFFS_EDIT = "/tariffs/:id/edit";

export const PATH_CUSTOMER_GROUPS = "/customer-groups";
export const PATH_CUSTOMER_GROUPS_ADD = "/customer-groups/add";
export const PATH_CUSTOMER_GROUPS_EDIT = "/customer-groups/:id/edit";

export const PATH_LOCATIONS = "/locations";
export const PATH_LOCATIONS_ADD = "/locations/add";
export const PATH_LOCATIONS_EDIT = "/locations/:id/edit";

export const PATH_STATIONS = "/stations";
export const PATH_STATIONS_ADD = "/stations/add";
export const PATH_STATIONS_EDIT = "/stations/:id/edit";
export const PATH_STATION_DETAILS = "/stations/:id/details";

export const PATH_CONFIGURATION = "/configuration";

export const PATH_404 = "/404";
export const PATH_MAINTENANCE = "/maintenance";

export const PATH_ICONS_LIST = "/icons-list";
